import { sensorGraphConstants } from "../../constants/client";

export const sensorGraph = {
  listing,
  listingSuccess,
  listingFailure,

  bulkListing,
  bulkListingSuccess,
};

function listing(payload) {
  return { type: sensorGraphConstants.LISTING_REQUEST, payload };
}

function listingSuccess(payload) {
  return { type: sensorGraphConstants.LISTING_SUCCESS, payload };
}

function listingFailure(error) {
  return { type: sensorGraphConstants.LISTING_FAILURE, error };
}

function bulkListing(payload) {
  return { type: sensorGraphConstants.BULK_LISTING_REQUEST, payload };
}

function bulkListingSuccess(payload) {
  return { type: sensorGraphConstants.BULK_LISTING_SUCCESS, payload };
}
